<template>
  <div>
    <v-progress-linear color="red" class='spinner' :indeterminate="true" :active="$spinner.visible"></v-progress-linear>
    <router-view></router-view>
    <v-snackbar
      :timeout="3000"
      :top="true"
      :right="true"
      :color="$toast.color"
      v-model="$toast.visible"
      class='toast'>

      <div class="toast-wrapper">
        <span class="toast-message" v-html="$toast.message"></span>

        <v-btn class="toast-btn-close" icon @click.native="$toast.visible = false">
          <v-icon dark>close</v-icon>
        </v-btn>
      </div>

    </v-snackbar>
  </div>
</template>

<script>
  export default {
    /**
     * Componente principal da aplicação.
     * Nele fica concentrado os componentes que tem uma única instancia como ex:
     * Toast, Progress Bar
     */
    data() {
      return {
      };
    },
  };
</script>

<style>
  .spinner {
    position: absolute;
    top: 0;
    z-index: 999999998;
    margin: 0 !important;
  }

  .toast {
    z-index: 999999999;
  }

  .toast div.v-snack__content {
    height: intrinsic !important;           /* Safari/WebKit uses a non-standard name */
    height: -moz-max-content !important;    /* Firefox/Gecko */
    height: -webkit-max-content !important; /* Chrome */
    display: table;
    height: auto !important;
  }

  .toast div.v-snack__content .toast-wrapper {
    display: table-row;
  }

  .toast div.v-snack__content .toast-wrapper .toast-message {
    display: table-cell;
    
  }

  .toast div.v-snack__content .toast-wrapper .toast-btn-close {
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue